"use strict";

exports.__esModule = true;
exports.default = void 0;

var _tokens = require("../../styles/tokens");

var styles = function styles(theme) {
  var _DayPickerDayOu, _root, _dateRangePickerRoot;

  return {
    // These styles are extending the original styles from react-day-picker@7.4.0
    // The root class is designed to be able to support all DatePicker styles, as well as
    // shared styles for other date selecting components (such as DateRangePicker)
    root: (_root = {
      margin: _tokens.spacing30 + " 0",

      /* DayPicker styles */
      '& .DayPicker': {
        display: 'inline-block',
        fontSize: _tokens.fontSizeDefault,
        fontFamily: _tokens.fontFamilyDefault,
        backgroundColor: theme.palette.grey[100],
        border: _tokens.borderWidthThin + " solid " + theme.palette.grey[400],
        position: 'relative',
        background: theme.palette.grey[100],
        borderRadius: _tokens.borderRadiusMedium,
        userSelect: 'none'
      },
      '& .DayPicker-wrapper': {
        position: 'relative',
        flexDirection: 'row',
        userSelect: 'none',
        '&:focus': {
          outlineColor: theme.palette.focus
        }
      },
      '& .DayPicker-Months': {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center'
      },
      '& .DayPicker-Month': {
        display: 'inline-table',
        margin: "0 " + _tokens.spacing30,
        paddingBottom: '1rem',
        borderSpacing: 0,
        borderCollapse: 'collapse',
        userSelect: 'none',
        '&:first-of-type': {
          display: 'block'
        }
      },
      '& .DayPicker-NavBar': {
        margin: "0.75rem " + _tokens.spacing30 + " 0"
      },
      '& .DayPicker-NavButton': {
        position: 'absolute',
        top: _tokens.spacing40,
        right: _tokens.spacing50,
        left: 'auto',
        display: 'inline-block',
        marginTop: '.125rem',
        width: '1.25rem',
        height: '1.25rem',
        backgroundPosition: 'center',
        backgroundSize: '50%',
        backgroundRepeat: 'no-repeat',
        cursor: 'pointer',
        '&:hover': {
          opacity: 0.8
        }
      },
      '& .DayPicker-NavButton--interactionDisabled': {
        display: 'none'
      },
      '& .DayPicker-Caption ': {
        display: 'table-caption',
        marginTop: _tokens.spacing30,
        marginBottom: _tokens.spacing20
      },
      '& .DayPicker-Weekdays': {
        display: 'table-header-group',
        marginTop: '1em'
      },
      '& .DayPicker-WeekdaysRow': {
        display: 'table-row',
        textTransform: 'uppercase'
      },
      '& .DayPicker-Weekday': {
        display: 'table-cell',
        padding: '0.75rem',
        color: theme.palette.grey[500],
        textAlign: 'center',
        fontSize: _tokens.fontSizeDefault
      },
      '& .DayPicker-Weekday abbr[title]': {
        borderBottom: 'none',
        textDecoration: 'none'
      },
      '& .DayPicker-Body': {
        display: 'table-row-group'
      },
      '& .DayPicker-Week': {
        display: 'table-row'
      },
      '& .DayPicker-WeekNumber': {
        display: 'table-cell',
        padding: '0.5em',
        minWidth: '1em',
        borderRight: '1px solid #EAECEC',
        color: '#8B9898',
        verticalAlign: 'middle',
        textAlign: 'right',
        fontSize: '0.75em',
        cursor: 'pointer'
      },
      // TODO: Look into
      '& .DayPicker--interactionDisabled .DayPicker-Day': {
        cursor: 'default'
      },
      // TODO: Look into used when footer is added to daypicker
      '& .DayPicker-Footer': {
        paddingTop: '0.5em',
        // Center today button
        display: 'flex',
        justifyContent: 'center'
      },
      // NOTE: We don't use this at the moment but might in the future.
      '& .DayPicker-TodayButton': {
        border: 'none',
        backgroundColor: 'transparent',
        backgroundImage: 'none',
        boxShadow: 'none',
        color: theme.palette.ctaColor.base,
        fontSize: '0.875em',
        cursor: 'pointer',
        padding: '4px 8px',
        '&:hover': {
          color: theme.palette.ctaColor.hover,
          cursor: 'pointer'
        },
        '&:active': {
          color: theme.palette.ctaColor.active
        },
        '&:focus': {
          outline: 'none',
          borderRadius: _tokens.borderRadiusMedium,
          boxShadow: "0 0 0 " + _tokens.borderWidthThick + " " + _tokens.colorBorderGlobalFocus
        }
      },
      // ========
      // Day Modifier Styles
      // ========
      // Default day styles
      '& .DayPicker-Day': {
        display: 'table-cell',
        borderRadius: _tokens.borderRadiusSmall,
        verticalAlign: 'middle',
        textAlign: 'center',
        cursor: 'pointer',
        width: '2.75rem',
        height: '2.75rem',
        color: theme.palette.grey[600],
        '&:focus': {
          outline: 'none',
          boxShadow: "inset 0 0 0 " + _tokens.borderWidthThick + " " + _tokens.colorBorderGlobalFocus
        }
      },
      '& .hedtech-day': {
        // this targets the actual day element
        borderRadius: _tokens.borderRadiusCircle,
        width: '1.875rem',
        height: '1.875rem',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        transition: theme.transitions.create(['background', 'background-color', 'color', 'outline'], {
          duration: 100
        })
      },
      // ========
      // Today styles
      // ========
      '& .DayPicker-Day--today': {
        '& .hedtech-day.DayPicker-Today': {
          fontWeight: _tokens.fontWeightBold,
          backgroundColor: theme.palette.ctaColor.tint,
          color: theme.palette.ctaColor.base
        }
      },
      // ========
      // Outside days
      // ========
      '& .DayPicker-Day--outside': (_DayPickerDayOu = {
        cursor: 'default',
        color: theme.palette.grey[500]
      }, _DayPickerDayOu["&.DayPicker-Day:not(.DayPicker-Day--disabled)"] = {
        '&:focus': {
          outline: 'none',
          '& .hedtech-day': {
            outline: 'none'
          }
        },
        '&:hover': {
          '& .hedtech-day': {
            cursor: 'pointer',
            backgroundColor: theme.palette.grey[250],
            color: theme.palette.grey[600]
          }
        },
        '&:active': {
          outline: 'none',
          '& .hedtech-day': {
            backgroundColor: theme.palette.ctaColor.active
          }
        }
      }, _DayPickerDayOu['& .hedtech-day'] = {
        '&:hover': {
          backgroundColor: theme.palette.grey[250],
          borderRadius: _tokens.borderRadiusCircle
        }
      }, _DayPickerDayOu),
      // ========
      // Disabled days
      // ========
      '& .DayPicker-Day--disabled': {
        '& .hedtech-day': {
          color: theme.palette.grey[400],
          backgroundColor: theme.palette.grey[250],
          '&:hover': {
            backgroundColor: theme.palette.grey[250],
            borderRadius: _tokens.borderRadiusCircle
          }
        },
        outline: 'none',
        '&:hover': {
          cursor: 'not-allowed'
        }
      },
      '& .DayPicker-Day--disabled:not(.DayPicker-Day--outside)': {},
      // ========
      // Disabled days
      // ========
      '& .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside)': {
        position: 'relative',
        '&:focus': {
          outlineColor: 'transparent'
        },
        // Selected, Today
        '& .DayPicker-Today': {
          color: theme.palette.grey[100]
        },
        '& > .hedtech-day': {
          color: theme.palette.grey[100],
          backgroundColor: theme.palette.ctaColor.base,
          '&:hover': {
            backgroundColor: theme.palette.ctaColor.hover
          }
        }
      }
    }, _root["& .DayPicker:not(.DayPicker--interactionDisabled) .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside)"] = {
      // disable defaults
      '&:focus': {
        outline: 'none',
        '& .hedtech-day': {
          outline: 'none'
        }
      },
      '&:hover': {
        '& .hedtech-day': {
          cursor: 'pointer',
          backgroundColor: theme.palette.grey[250]
        }
      },
      '&:active': {
        outline: 'none',
        '& .hedtech-day': {
          backgroundColor: theme.palette.ctaColor.active
        }
      }
    }, _root['& .DayPickerInput'] = {
      display: 'inline-block'
    }, _root['& .DayPickerInput-OverlayWrapper'] = {
      position: 'relative'
    }, _root['& .DayPickerInput-Overlay'] = {
      position: 'absolute',
      left: 0,
      zIndex: 1,
      background: 'white',
      boxShadow: '0 2px 5px rgba(0, 0, 0, 0.15)'
    }, _root),
    singleMonth: {},

    /**
     * By default, RDP does not block out or 'hide' the outside days styles.
     */
    hideOutsideDays: {
      '& .DayPicker-Day--outside': {
        cursor: 'default',
        backgroundColor: theme.palette.grey[100],
        '&:focus, &:hover': {
          cursor: 'default',
          backgroundColor: theme.palette.grey[100]
        }
      }
    },
    // These are DateRangePicker
    dateRangePickerRoot: (_dateRangePickerRoot = {
      '& .DayPicker-Month': {
        display: 'block',
        '&:first-of-type': {
          display: 'block',
          paddingRight: '0.75rem',
          borderRight: "solid " + _tokens.borderWidthThin + " " + theme.palette.grey[300]
        }
      },
      // Disable border for when single month is showing
      '&$singleMonth .DayPicker-Month': {
        '&:first-of-type': {
          display: 'inline-table',
          paddingRight: 0,
          borderRight: 'none'
        }
      },
      '&.hedtech-DateRangePicker .DayPicker-Day--hover:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside)': {
        '&:first-child': {
          '& .hedtech-day': {
            borderRadius: _tokens.borderRadiusMedium + " 0 0 " + _tokens.borderRadiusMedium
          },
          '&:focus, &:hover': {
            '& .hedtech-day': {
              borderRadius: _tokens.borderRadiusCircle
            }
          }
        },
        '&:last-child': {
          '& .hedtech-day': {
            borderRadius: "0 " + _tokens.borderRadiusMedium + " " + _tokens.borderRadiusMedium + " 0"
          },
          '&:focus, &:hover': {
            '& .hedtech-day': {
              borderRadius: _tokens.borderRadiusCircle
            }
          }
        },
        '& .hedtech-day': {
          width: '100%',
          borderRadius: 0,
          outline: 'none',
          backgroundColor: theme.palette.ctaColor.tint,
          color: theme.palette.grey[600]
        },
        '& .DayPicker-Today': {
          color: theme.palette.ctaColor.base
        },
        '&:focus, &:hover': {
          '& .hedtech-day': {
            width: '1.875rem',
            borderRadius: '50%'
          }
        }
      },
      // ========
      // DateRange of days that are selected, in between the start and end days
      // ========
      '&.hedtech-DateRangePicker .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside)': {
        backgroundColor: theme.palette.grey[100],
        '&:first-child': {
          '& .hedtech-day': {
            borderRadius: "14px 0 0 14px"
          }
        },
        '&:last-child': {
          '& .hedtech-day': {
            borderRadius: "0 14px 14px 0"
          }
        },
        '&:first-child, &:last-child': {
          '&:focus, &:hover': {
            '& .hedtech-day': {
              borderRadius: '50%'
            }
          }
        },
        '& .hedtech-day': {
          width: '100%',
          backgroundColor: theme.palette.ctaColor.tint,
          color: theme.palette.grey[600],
          borderRadius: '0',
          fontWeight: _tokens.fontWeightNormal
        },
        '& .DayPicker-Today': {
          color: theme.palette.ctaColor.base
        },
        '&:focus, &:hover': {
          backgroundColor: theme.palette.grey[100],
          outline: 'none',
          '&:first-child, &:last-child': {
            '& .hedtech-day': {
              borderRadius: "14px 0 0 14px",
              width: '1.875rem'
            }
          },
          '& .hedtech-day': {
            borderRadius: '50%',
            width: '1.875rem',
            outline: 'none',
            backgroundColor: _tokens.colorBrandNeutral250,
            color: theme.palette.grey[600]
          },
          '& .DayPicker-Today': {
            color: theme.palette.ctaColor.base
          }
        },
        '& .DayPicker-Day--today': {
          '& .hedtech-day': {
            fontWeight: _tokens.fontWeightNormal
          }
        }
      },
      // ========
      // Start and End days
      // ========
      '&.hedtech-DateRangePicker .DayPicker-Day--start.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside), &.hedtech-DateRangePicker .DayPicker-Day--end.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside)': {
        position: 'relative',
        zIndex: 1,
        '&:first-child': {
          '& .hedtech-day': {
            borderRadius: _tokens.borderRadiusCircle
          }
        },
        '&:last-child': {
          '& .hedtech-day': {
            borderRadius: _tokens.borderRadiusCircle
          }
        },
        '&:before': {
          right: 0,
          width: '1.5rem',
          // ~ half of parent div
          height: '1.875rem',
          content: '""',
          display: 'block',
          position: 'absolute',
          // this creates a new stacking z-index
          zIndex: -1,
          backgroundColor: theme.palette.ctaColor.tint
        },
        '& .hedtech-day': {
          width: '1.875rem',
          backgroundColor: "" + theme.palette.ctaColor.base,
          color: theme.palette.grey[100],
          borderRadius: '50%',
          fontWeight: _tokens.fontWeightBold
        },
        '&:hover': {
          '& .hedtech-day': {
            backgroundColor: theme.palette.ctaColor.hover,
            color: theme.palette.grey[100]
          }
        },
        '&:focus, &:active': {
          outline: 'none',
          '& .hedtech-day': {
            outline: 'none',
            backgroundColor: theme.palette.ctaColor.hover,
            color: theme.palette.grey[100]
          }
        }
      },
      // When Start and End date are the same day
      '&.hedtech-DateRangePicker .DayPicker-Day--end.DayPicker-Day--start.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside)': {
        '&:before': {
          backgroundColor: theme.palette.grey[100]
        }
      },
      // Start date
      '&.hedtech-DateRangePicker .DayPicker-Day--start.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) ': {
        '&:before': {
          right: 0
        }
      },
      // End date
      '&.hedtech-DateRangePicker .DayPicker-Day--end.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside)': {
        '&:before': {
          left: '0 !important'
        }
      }
    }, _dateRangePickerRoot[theme.breakpoints.down('sm')] = {
      '& .DayPicker-Month': {
        '&:first-of-type': {
          display: 'inline-table',
          paddingRight: 0,
          borderRight: 'none'
        }
      }
    }, _dateRangePickerRoot)
  };
};

var _default = styles;
exports.default = _default;